// @flow
import Box from "@mui/material/Box";
import { GridEditInputCell } from "@mui/x-data-grid-premium";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import PageContentWrapper from "../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
import DataGridWrapper from "../../../components/mui/grids/dataGridWrapper/dataGridWrapper";
import EditableMUICellValidation
	from "../../../components/mui/grids/editableMUICellValidation/editableMUICellValidation";
import EditableMUIDataGrid from "../../../components/mui/grids/editableMUIDataGrid/editableMUIDataGrid";
import { access_parameters, access_skills } from "../../../helpers/rights";
import { withPermissionHOC } from "../../permission/components/permissionHOC/permissionHOC";
import useSpecialties from "../hooks/useSpecialties";
import { SPECIALTIES } from "../locales/namespaces";

type Props = {};

const Specialties = (props: Props) => {
	const { t } = useTranslation(SPECIALTIES)
	const {
		data,
		isLoading,
		total,
		store,
		remove,
		update,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
	} = useSpecialties()
	
	const newRowModel = {
		Description: '',
	}
	
	const columns = useMemo(() => [
		
		{
			field: 'Description',
			headerName: t('Description'),
			width: 150, maxWidth: 300, flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value
				if (!inputValue) {
					return { ...params.props, error: t('Description is required') }
				}
				return { ...params.props, error: null } // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
	
	], [t])
	
	return (
		<Box className="specialties_index">
			<PageContentWrapper> {/* Wrapper component που δημιουργεί συγκεκριμένο style γύρω από τα grid και τον τίτλο στην index. */}
				<PageTitle
					title={t('Specialties')}/>
				<DataGridWrapper sx={{ height: 600, maxWidth: '700px' }}>
					<EditableMUIDataGrid
						data={data}
						columns={columns}
						loading={isLoading}
						newRowModel={newRowModel}
						store={store}
						remove={remove}
						update={update}
						dataGridProOtherProps={{
							pagination: true,
							paginationModel: { page, pageSize },
							paginationMode: "server",
							onPaginationModelChange: onPaginationModelChange,
							rowCount: Number(total),
							pageSizeOptions: [5, 10, 15, 20, 50, 100],
							sortingMode: "server",
							onSortModelChange: (sortModel) => onSortModelChange(sortModel),
							filterMode: "server",
							onFilterModelChange: onFilterModelChange,
						}}
					/>
				</DataGridWrapper>
			</PageContentWrapper>
		</Box>
	);
};

export default withPermissionHOC(Specialties, [access_skills])